


































import {
  Component,
  Vue,
} from 'vue-property-decorator';

import bImg from 'bootstrap-vue/es/components/image/img';
import bLink from 'bootstrap-vue/es/components/link/link';

import { ProductVariant } from '@/models';

import ProductFeature from './ProductFeature';

@Component({
  components: {
    bImg,
    bLink,
  },
})
export default class ShareButtonsFeature extends ProductFeature {}

